export default __webpack_public_path__ + "static/media/misc-pantry2-1440w.1a181267.avif";